import apiClient from '../../shared/services/apiClient';

/**
 * Log Service (Admin Only)
 *
 * Handles admin-level log viewing and analysis.
 * Provides access to job logs, order logs, and system logs.
 *
 * All routes use /api/admin/logs/* prefix
 */
const logService = {
    /**
     * Get job execution logs
     * @param {Object} params - Query parameters
     * @returns {Promise}
     */
    getJobLogs: async (params = {}) => {
        try {
            const response = await apiClient.get('/api/admin/logs/jobs', { params });
            return response.data;
        } catch (error) {
            console.error('Failed to get job logs:', error);
            throw error;
        }
    },

    /**
     * Get job execution log detail
     * @param {number} id - Job log ID
     * @returns {Promise}
     */
    getJobLog: async (id) => {
        try {
            const response = await apiClient.get(`/api/admin/logs/jobs/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Failed to get job log ${id}:`, error);
            throw error;
        }
    },

    /**
     * Get order process logs
     * @param {Object} params - Query parameters
     * @returns {Promise}
     */
    getOrderLogs: async (params = {}) => {
        try {
            const response = await apiClient.get('/api/admin/logs/orders', { params });
            return response.data;
        } catch (error) {
            console.error('Failed to get order logs:', error);
            throw error;
        }
    },

    /**
     * Get order process log detail
     * @param {number} id - Order log ID
     * @returns {Promise}
     */
    getOrderLog: async (id) => {
        try {
            const response = await apiClient.get(`/api/admin/logs/orders/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Failed to get order log ${id}:`, error);
            throw error;
        }
    },

    /**
     * Get system log content
     * @param {Object} params - Query parameters (file, lines, search)
     * @returns {Promise}
     */
    getSystemLog: async (params = {}) => {
        try {
            const response = await apiClient.get('/api/admin/logs/system', { params });
            return response.data;
        } catch (error) {
            console.error('Failed to get system log:', error);
            throw error;
        }
    },

    /**
     * Get list of available log files
     * @returns {Promise}
     */
    getSystemLogFiles: async () => {
        try {
            const response = await apiClient.get('/api/admin/logs/system/files');
            return response.data;
        } catch (error) {
            console.error('Failed to get system log files:', error);
            throw error;
        }
    },

    /**
     * Get log statistics
     * @param {Object} params - Query parameters (hours)
     * @returns {Promise}
     */
    getStats: async (params = { hours: 24 }) => {
        try {
            const response = await apiClient.get('/api/admin/logs/stats', { params });
            return response.data;
        } catch (error) {
            console.error('Failed to get log stats:', error);
            throw error;
        }
    }
};

export default logService;
